import {useTranslation} from '@aboutyou/i18n';

export const useWishlistSortingOptions = () => {
  const {t} = useTranslation();

  return [
    {
      id: 'recently_added',
      label: t('Recently added'),
    },
    {
      id: 'highest_reduction',
      label: t('Maximum reduction'),
    },
    {
      id: 'price_high',
      label: t('Highest price'),
    },
    {
      id: 'price_low',
      label: t('Lowest price'),
    },
    {
      id: 'low_stock',
      label: t('Low Stock'),
    },
  ];
};
